(() => {
  const root = document.querySelector('[data-custom-design-studio]');
  if (!root) return;

  const productSelect = root.querySelector('[data-custom-product]');
  const sizeSelect = root.querySelector('[data-custom-size]');
  const artworkInput = root.querySelector('[data-custom-artwork]');
  const notesInput = root.querySelector('[data-custom-notes]');
  const generateBtn = root.querySelector('[data-generate-preview]');
  const regenerateBtn = root.querySelector('[data-regenerate-preview]');
  const confirmBtn = root.querySelector('[data-confirm-design]');
  const addBtn = root.querySelector('[data-add-custom-to-cart]');
  const status = root.querySelector('[data-custom-status]');
  const preview = root.querySelector('[data-preview-image]');
  const placeholder = root.querySelector('[data-preview-placeholder]');
  const actions = root.querySelector('[data-preview-actions]');
  const summary = root.querySelector('[data-custom-summary]');
  const artworkPreview = root.querySelector('[data-artwork-preview]');
  const summaryProduct = root.querySelector('[data-summary-product]');
  const summarySize = root.querySelector('[data-summary-size]');
  const summaryPrice = root.querySelector('[data-summary-price]');
  const variantDataEl = root.querySelector('[data-custom-variant-data]');

  let selectedPreview = false;
  let artworkDataUrl = '';
  let selectedVariant = null;
  let variantsByProduct = {};

  try {
    variantsByProduct = JSON.parse(variantDataEl?.textContent || '{}');
  } catch (error) {
    console.error('Custom Design Studio variant data error:', error);
  }

  function selectedProductOption() {
    return productSelect?.selectedOptions?.[0];
  }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
        style: 'currency',
        currency: window.Shopify?.currency?.active || 'USD'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return `$${(Number(cents || 0) / 100).toFixed(2)}`;
    }
  }

  function populateSizes(productId) {
    sizeSelect.innerHTML = '';
    selectedVariant = null;
    selectedPreview = false;
    addBtn.disabled = true;
    addBtn.textContent = 'ADD CUSTOM DESIGN TO CART';

    if (!productId) {
      sizeSelect.disabled = true;
      sizeSelect.innerHTML = '<option value="">Select a product first</option>';
      updateSummary();
      return;
    }

    const variants = (variantsByProduct[productId] || []).filter((variant) => variant.available);

    if (!variants.length) {
      sizeSelect.disabled = true;
      sizeSelect.innerHTML = '<option value="">No available sizes</option>';
      status.textContent = 'This custom product currently has no available variants.';
      updateSummary();
      return;
    }

    sizeSelect.disabled = false;
    sizeSelect.innerHTML = '<option value="">Select a size</option>';

    variants.forEach((variant) => {
      const option = document.createElement('option');
      option.value = String(variant.id);
      option.textContent = variant.title === 'Default Title' ? 'Standard' : variant.title;
      option.dataset.price = variant.price;
      option.dataset.variantId = variant.id;
      sizeSelect.appendChild(option);
    });

    if (variants.length === 1) {
      sizeSelect.value = String(variants[0].id);
      selectedVariant = variants[0];
    }

    updateSummary();
  }

  function updateSummary() {
    const productOption = selectedProductOption();
    const sizeOption = sizeSelect?.selectedOptions?.[0];

    if (!productOption || !productOption.value) {
      summary.hidden = true;
      addBtn.disabled = true;
      return;
    }

    if (sizeOption?.value) {
      selectedVariant = (variantsByProduct[productOption.value] || []).find(
        (variant) => String(variant.id) === String(sizeOption.value)
      ) || null;
    } else {
      selectedVariant = null;
    }

    summaryProduct.textContent = productOption.dataset.productTitle || 'Custom product';
    summarySize.textContent = selectedVariant
      ? (selectedVariant.title === 'Default Title' ? 'Standard' : selectedVariant.title)
      : 'Select a size';
    summaryPrice.textContent = selectedVariant ? formatMoney(selectedVariant.price) : '—';
    summary.hidden = false;
    addBtn.disabled = !(selectedPreview && selectedVariant);
  }

  function showArtworkPreview(file) {
    artworkPreview.innerHTML = '';
    if (!file) {
      artworkPreview.hidden = true;
      return;
    }
    if (file.type.startsWith('image/')) {
      const img = document.createElement('img');
      img.alt = 'Uploaded artwork';
      const reader = new FileReader();
      reader.onload = () => {
        artworkDataUrl = reader.result;
        img.src = artworkDataUrl;
      };
      reader.readAsDataURL(file);
      artworkPreview.appendChild(img);
    } else {
      const p = document.createElement('p');
      p.textContent = `✓ ${file.name} selected`;
      artworkPreview.appendChild(p);
    }
    artworkPreview.hidden = false;
  }

  function validate() {
    if (!productSelect.value) {
      status.textContent = 'Please choose a custom product first.';
      productSelect.focus();
      return false;
    }
    if (!selectedVariant) {
      status.textContent = 'Please choose a size first.';
      sizeSelect.focus();
      return false;
    }
    if (!artworkInput.files[0]) {
      status.textContent = 'Please upload your artwork first.';
      artworkInput.focus();
      return false;
    }
    if (artworkInput.files[0].size > 20 * 1024 * 1024) {
      status.textContent = 'Your file is larger than 20 MB.';
      return false;
    }
    return true;
  }

  function localPreview() {
    const file = artworkInput.files[0];
    if (!file || !file.type.startsWith('image/')) return false;
    preview.src = artworkDataUrl;
    preview.hidden = false;
    placeholder.hidden = true;
    actions.hidden = false;
    selectedPreview = false;
    addBtn.disabled = true;
    status.textContent = 'Preview ready. The AI mockup connection will replace this local preview in Phase 2.';
    updateSummary();
    return true;
  }

  async function addToCart() {
    if (!selectedPreview || !selectedVariant) return;
    const productOption = selectedProductOption();
    addBtn.disabled = true;
    addBtn.textContent = 'ADDING…';

    const properties = {
      'Custom Design ID': `CD-${Date.now()}`,
      'Product': productOption?.dataset.productTitle || '',
      'Size': selectedVariant.title === 'Default Title' ? 'Standard' : selectedVariant.title,
      'Customer Requirements': notesInput.value || 'None',
      'Artwork File': artworkInput.files[0]?.name || 'Uploaded artwork',
      'Preview': 'Customer-approved preview'
    };

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(selectedVariant.id), quantity: 1, properties}]})
      });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.href = window.Shopify.routes.root + 'cart';
    } catch (error) {
      console.error(error);
      status.textContent = 'We could not add your custom design to the cart. Please try again.';
      addBtn.disabled = false;
      addBtn.textContent = 'ADD CUSTOM DESIGN TO CART';
    }
  }

  productSelect?.addEventListener('change', () => {
    populateSizes(productSelect.value);
  });

  sizeSelect?.addEventListener('change', () => {
    updateSummary();
  });

  artworkInput?.addEventListener('change', () => showArtworkPreview(artworkInput.files[0]));

  generateBtn?.addEventListener('click', () => {
    if (!validate()) return;
    generateBtn.disabled = true;
    generateBtn.textContent = 'PREPARING PREVIEW…';
    setTimeout(() => {
      localPreview();
      generateBtn.disabled = false;
      generateBtn.textContent = 'GENERATE MY DESIGN';
    }, 700);
  });

  regenerateBtn?.addEventListener('click', () => {
    selectedPreview = false;
    addBtn.disabled = true;
    status.textContent = 'Ready to regenerate. AI generation will be connected in Phase 2.';
  });

  confirmBtn?.addEventListener('click', () => {
    selectedPreview = true;
    addBtn.disabled = !selectedVariant;
    status.textContent = selectedVariant
      ? 'Design preview selected. You can now add your custom product to cart.'
      : 'Design preview selected. Please choose a size before adding to cart.';
    confirmBtn.textContent = '✓ DESIGN SELECTED';
    updateSummary();
  });

  addBtn?.addEventListener('click', addToCart);
  updateSummary();
})();
